import { render, staticRenderFns } from "./InputFilter.vue?vue&type=template&id=64a95190&"
import script from "./InputFilter.vue?vue&type=script&lang=js&"
export * from "./InputFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports